import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "audit-form-block" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[0] || (_cache[0] = _createElementVNode("h5", null, "Audit", -1)),
    _createElementVNode("ul", null, [
      _createElementVNode("li", null, "Created: " + _toDisplayString(_ctx.entity.creationTime), 1),
      _createElementVNode("li", null, "Updated: " + _toDisplayString(_ctx.entity.lastModificationTime), 1)
    ])
  ]))
}